var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.theme === 'light')?_c('Light'):_vm._e(),(_vm.theme === 'dark')?_c('Dark'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }